import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineChart3"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H20V4H22ZM16 8V20H14V8H16ZM10 12V20H8L8 12H10ZM4 16V20H2V16H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart3;
